module.exports = __webpack_public_path__ + "img/teeth-24.5012ca83.png";